var _rect, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.4999,
    y: 0.5,
    width: 21,
    height: 15,
    rx: 1.5,
    transform: "rotate(90 15.4999 0.5)",
    fill: "#1B1B1B",
    stroke: "#1B1B1B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.58362,
    y1: 4.43274,
    x2: 13.5688,
    y2: 4.43274,
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.58362,
    y1: 6.06726,
    x2: 13.5688,
    y2: 6.06726,
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditionActive);
export default __webpack_public_path__ + "static/media/audition-active.4af7e4e356d8ad0f54070e2c535e511e.svg";
export { ForwardRef as ReactComponent };